// Collection page tag filter — search + alphabet jump + auto-submit on change.

const filterForm = document.querySelector('[data-filter-form]');
const filterSearch = document.querySelector('[data-filter-search]');
const filterList = document.querySelector('[data-filter-list]');
const filterAlphabet = document.querySelector('[data-filter-alphabet]');
const filterToggleBtn = document.querySelector('[data-filter-toggle]');
const filterAside = document.querySelector('[data-collection-filters]');
const filterCloseBtn = document.querySelector('[data-close-filters]');

if (filterForm) {
  // Auto-submit on checkbox change so the filter persists via URL params.
  filterForm.addEventListener('change', (e) => {
    if (e.target.matches('[data-filter-input]')) {
      filterForm.submit();
    }
  });
}

if (filterSearch && filterList) {
  // Live-filter the visible tag list as the user types.
  filterSearch.addEventListener('input', () => {
    const term = filterSearch.value.trim().toLowerCase();
    let firstVisibleLetter = null;
    filterList.querySelectorAll('.filter-item').forEach((item) => {
      const name = item.dataset.name || '';
      const match = !term || name.toLowerCase().includes(term);
      item.hidden = !match;
      if (match && !firstVisibleLetter) firstVisibleLetter = item.dataset.letter;
    });
    // Highlight the first available letter in the alphabet bar.
    if (filterAlphabet) {
      filterAlphabet.querySelectorAll('.filter-letter').forEach((btn) => {
        btn.classList.toggle('available', false);
      });
      const visibleLetters = new Set(
        Array.from(filterList.querySelectorAll('.filter-item:not([hidden])')).map(
          (i) => i.dataset.letter
        )
      );
      filterAlphabet.querySelectorAll('.filter-letter').forEach((btn) => {
        btn.classList.toggle('available', visibleLetters.has(btn.dataset.letter));
        btn.disabled = !visibleLetters.has(btn.dataset.letter);
      });
    }
  });
}

if (filterAlphabet && filterList) {
  // Pre-mark which letters have any items.
  const initialLetters = new Set(
    Array.from(filterList.querySelectorAll('.filter-item')).map((i) => i.dataset.letter)
  );
  filterAlphabet.querySelectorAll('.filter-letter').forEach((btn) => {
    btn.classList.toggle('available', initialLetters.has(btn.dataset.letter));
    btn.disabled = !initialLetters.has(btn.dataset.letter);
  });

  // Clicking a letter scrolls the list to the first matching item.
  filterAlphabet.addEventListener('click', (e) => {
    const btn = e.target.closest('.filter-letter');
    if (!btn || btn.disabled) return;
    const target = filterList.querySelector(
      `.filter-item[data-letter="${btn.dataset.letter}"]:not([hidden])`
    );
    if (target) {
      target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  });
}

// Mobile drawer
if (filterToggleBtn && filterAside) {
  filterToggleBtn.addEventListener('click', () => {
    filterAside.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
}
if (filterCloseBtn && filterAside) {
  filterCloseBtn.addEventListener('click', () => {
    filterAside.classList.remove('open');
    document.body.style.overflow = '';
  });
}
